import React, { useRef } from 'react'
import './testimonials.css'
import AVTR1 from '../../assests/UBI.jpg'
import AVTR2 from '../../assests/TR.jpg'
import AVTR3 from '../../assests/AM.jpg'
import AVTR4 from '../../assests/RA.png'
import AVTR5 from '../../assests/JI.png'

import {Pagination} from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/swiper.min.css'
import 'swiper/css/pagination';



const data =[
 {
    avatar: AVTR5,
    name: 'Javeria Ilyas',
    position: 'Software Team Lead | Byonyks - US based Medical Device Company',
    review: <h5>“Abdullah has been a key contributor to our Linux-based C++ software systems at Byonyks. He consistently demonstrates strong technical depth in hardware–software integration, playing a critical role in ensuring the reliability of our medical technology devices. His professionalism, ownership mindset, and problem-solving ability make him a highly dependable engineer."</h5>
  },
  {
    avatar: AVTR2,
    name: 'Tausif Ul Rehman',
    position: 'CEO & Founder | GlowingSoft Technologies',
    review: <h5>"Abdullah Sattar is an incredible leader and passionate programmer. I'm really impressed with his intuition and problem-solving skills. I can see him as a very successful and highly dynamic innovator."</h5>
  },
  {
    avatar: AVTR1,
    name: 'Usman Bin Imran',
    position: 'CEO & Founder | DATXOC',
    review: <h5>"Abdullah's expertise in the field of technology is remarkable. His deep understanding of cutting-edge technologies and ability to apply them in practical ways have significantly propelled our company's growth. One of Abdullah's most remarkable qualities is his strong leadership. He has an extraordinary knack for identifying opportunities and implementing solutions that meet business objectives but also exceed our client's expectations. I wholeheartedly recommend Abdullah for any leadership or technical position."</h5>
  },
  {
    avatar: AVTR4,
    name: 'Raahim Ahmad Khan',
    position: 'Pod Lead | Turing',
    review: <h5>“I had the privilege of working with Abdullah on a fast-paced delivery project with tight deadlines. His ability to understand complex concepts quickly and turn them into high-quality, production-ready results was impressive. He consistently delivered on time without compromising quality a rare balance in high-pressure environments.”</h5>
  },
  {
    avatar: AVTR3,
    name: 'Ahsan Mehmood',
    position: 'Full Stack Developer | Visnext',
    review: <h5>"Abdullah is known for his excellent problem-solving skills and his ability to approach challenges with a positive attitude. Abdullah's skills as a software developer and his unwavering dedication to excellence make him a valuable asset to any organization."</h5>
  }
]

const Testimonials = () => {
  const swiperRef = useRef(null)

  return (
    <section id='testimonials'>
      <h5>What Professionals Say</h5>
      <h2>Testimonials</h2>
      <div className='container testimonials_wrapper'>
        <Swiper className='testimonials_container'
        onSwiper={(swiper) => { swiperRef.current = swiper }}
        pagination={{ clickable: true }}
        modules={[Pagination]}
        spaceBetween={50}
        slidesPerView={1}
        loop={true}
        >
        {
          data.map(({avatar, name, position, review}, index) => {
            return(
              <SwiperSlide key={index} className='testimonials'>
                <div className='client_avatar'>
                  <img src={avatar} alt=''/>            
                </div>
                <h4 className='client_name'>{name}</h4>
                <h5 className='client_position'>{position}</h5>
                <small className='client_review'>{review}</small>
              </SwiperSlide>
            )
          })
        }
        </Swiper>
        <button className='testimonials_btn-prev' onClick={() => swiperRef.current?.slidePrev()}>&lsaquo;</button>
        <button className='testimonials_btn-next' onClick={() => swiperRef.current?.slideNext()}>&rsaquo;</button>
      </div>
    </section>
  )
}

export default Testimonials